import React from 'react';

const path = process.env.PUBLIC_URL

const Title = ({ title, performer }) => {
  return (
    <div className="title">
      <img src={`${path}/images/sun.svg`} className="absolute left-1/2 translate-x-[-50%] top-0 h-full object-cover" />
      <img src={`${path}/images/head.svg`} className="absolute h-[20vh] max-h-[170px] left-1/2 translate-x-[-50%] top-[32%] w-full object-fill max-w-[550px]" />
      <div className="title__wrapper absolute top-[55%] text-center w-full">
        <h3>{title}</h3>
        <p>{performer}</p>
      </div>
    </div>
  )
};

export default Title;
